module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content setting"
  }, [_c('h2', [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "b-b m-b-md"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('form', [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("昵称：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userinfo.nickname),
      expression: "userinfo.nickname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "昵称：轻舞飞扬",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userinfo.nickname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userinfo.nickname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.nickname))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userinfo.realname),
      expression: "userinfo.realname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "姓名：华宇互联",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userinfo.realname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userinfo.realname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.realname))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("邮箱：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 n-p-r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userinfo.email),
      expression: "userinfo.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "邮箱：test@test.com",
      "required": "required",
      "readonly": _vm.action_status.email === 0,
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userinfo.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userinfo.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 n-p-l-r"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.action_status.email === 0),
      expression: "action_status.email===0"
    }],
    staticClass: "small color-primary pointer",
    on: {
      "click": function($event) {
        _vm.edit(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.action_text.email))]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.action_status.email === 1),
      expression: "action_status.email===1"
    }],
    staticClass: "small color-primary pointer",
    on: {
      "click": function($event) {
        _vm.cancel(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.action_text.email))])])]), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.email))]), _vm._v(" "), _c('verify-code', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.action_status.email !== 0),
      expression: "action_status.email !== 0"
    }],
    attrs: {
      "val": _vm.userinfo.email,
      "msg": _vm.error.email,
      "type": 2
    },
    on: {
      "success": _vm.verifySuccess
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("手机：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 n-p-r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userinfo.phone),
      expression: "userinfo.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "手机：18888888888",
      "required": "required",
      "readonly": _vm.action_status.phone === 0,
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userinfo.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userinfo.phone = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 n-p-l-r"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.action_status.phone === 0),
      expression: "action_status.phone===0"
    }],
    staticClass: "small color-primary pointer",
    on: {
      "click": function($event) {
        _vm.edit(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.action_text.phone))]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.action_status.phone === 1),
      expression: "action_status.phone===1"
    }],
    staticClass: "small color-primary pointer",
    on: {
      "click": function($event) {
        _vm.cancel(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.action_text.phone))])])]), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.phone))]), _vm._v(" "), _c('verify-code', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.action_status.phone !== 0),
      expression: "action_status.phone !== 0"
    }],
    attrs: {
      "val": _vm.userinfo.phone,
      "msg": _vm.error.phone,
      "type": 1
    },
    on: {
      "success": _vm.verifySuccess
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("性别：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "m-t-b-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userinfo.sex),
      expression: "userinfo.sex",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "radio",
      "value": "1",
      "required": "required",
      "name": "sex",
      "autocomplete": "off"
    },
    domProps: {
      "checked": _vm._q(_vm.userinfo.sex, "1")
    },
    on: {
      "__c": function($event) {
        _vm.userinfo.sex = "1"
      }
    }
  }), _vm._v("男\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userinfo.sex),
      expression: "userinfo.sex",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "radio",
      "value": "2",
      "required": "required",
      "name": "sex",
      "autocomplete": "off"
    },
    domProps: {
      "checked": _vm._q(_vm.userinfo.sex, "2")
    },
    on: {
      "__c": function($event) {
        _vm.userinfo.sex = "2"
      }
    }
  }), _vm._v("女\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.sex))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("年龄：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userinfo.age),
      expression: "userinfo.age",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "年龄：18",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userinfo.age)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userinfo.age = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.age))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 text-right n-p-r"
  }, [_vm._v("\n                                毕业院校：\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userinfo.edu_school),
      expression: "userinfo.edu_school",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input input-md",
    attrs: {
      "type": "text",
      "placeholder": "毕业院校:清华大学"
    },
    domProps: {
      "value": (_vm.userinfo.edu_school)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userinfo.edu_school = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 text-right n-p-r"
  }, [_vm._v("\n                                最高学历：\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userinfo.education),
      expression: "userinfo.education",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input-md col-xs-12",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userinfo.education = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("博士")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("硕士")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("本科")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("专科")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("高中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("其他")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 text-right n-p-r"
  }, [_vm._v("\n                                工作年限：\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userinfo.work_year),
      expression: "userinfo.work_year",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input-md col-xs-12",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userinfo.work_year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("应届生")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1年")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2年")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3年")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4年")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5年")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6年")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7年")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8年")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9年")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10年")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("10年以上")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("QQ：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userinfo.qq),
      expression: "userinfo.qq",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "QQ：10000",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userinfo.qq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userinfo.qq = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.qq))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("签名：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userinfo.signature),
      expression: "userinfo.signature",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input textarea",
    attrs: {
      "resize": "none",
      "placeholder": "个性签名：人在江湖飘，就是要挨刀！",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userinfo.signature)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userinfo.signature = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 "
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.userinfo.avatar,
      "alt": _vm.userinfo.nickname
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-t-sm text-center"
  }, [_vm._v("\n                        (推荐尺寸:200 x 200,3M以内)\n                    ")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "p-t-b-md text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.editable
    },
    on: {
      "click": function($event) {
        _vm.completeInfo()
      }
    }
  }, [_vm._v("保存用户信息")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-t-sm text-center"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary upload-btn",
    attrs: {
      "type": "button",
      "id": "upload-avatar-btn"
    }
  }, [_vm._v("选择头像")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fc827a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/setting.vue
// module id = 477
// module chunks = 1